"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statementSchema = exports.StatementType = void 0;
var jsonschema_1 = require("../utils/jsonschema");
var StatementType;
(function (StatementType) {
    StatementType["Comment"] = "COMMENT";
    StatementType["Switch"] = "SWITCH";
    StatementType["ForEach"] = "FOR_EACH";
    StatementType["Return"] = "RETURN";
    StatementType["Break"] = "BREAK";
    StatementType["Throw"] = "THROW";
    StatementType["Try"] = "TRY";
    StatementType["SetVariable"] = "SET_VARIABLE";
    StatementType["FunctionCall"] = "FUNCTION_CALL";
})(StatementType = exports.StatementType || (exports.StatementType = {}));
exports.statementSchema = {
    $id: jsonschema_1.$id('statement'),
    title: 'Statement',
    anyOf: [
        { $ref: jsonschema_1.$id('commentStatement') },
        { $ref: jsonschema_1.$id('switchStatement') },
        { $ref: jsonschema_1.$id('forEachStatement') },
        { $ref: jsonschema_1.$id('returnStatement') },
        { $ref: jsonschema_1.$id('breakStatement') },
        { $ref: jsonschema_1.$id('throwStatement') },
        { $ref: jsonschema_1.$id('tryStatement') },
        { $ref: jsonschema_1.$id('setVariableStatement') },
        { $ref: jsonschema_1.$id('functionCallStatement') }
    ]
};
//# sourceMappingURL=statements.js.map